import { Controller } from 'stimulus';

const APPLE_PAY_VERSION = 3;

const MOLLIE_APPLE_PAY_SESSION_URL = 'https://api.mollie.com/v2/wallets/applepay/sessions';

const MERCHANT_NAME = 'Bekking & Blitz';

class ApplePay extends Controller {
  connect() {
    if (!window.ApplePaySession || !window.ApplePaySession.canMakePayments()) {
      return;
    }

    this.element.style.display = 'block';
  }

  onApplePayClick() {
    this.createApplePaySession(MERCHANT_NAME, '00.10');
  }

  // eslint-disable-next-line class-methods-use-this
  createApplePaySession(label, amount) {
    const total = {
      label,
      amount,
    };

    const request = {
      countryCode: 'NL',
      currencyCode: 'EUR',
      supportedNetworks: ['amex', 'maestro', 'masterCard', 'visa', 'vPay'],
      merchantCapabilities: ['supports3DS'],
      total,
    };

    this.session = new window.ApplePaySession(APPLE_PAY_VERSION, request);

    this.session.onvalidatemerchant = this.onValidateMerchant.bind(this);

    this.session.onpaymentmethodselected = () => {
      this.log('onpaymentmethodselected');
      this.session.completePaymentMethodSelection(total);
    };

    this.session.onshippingcontactselected = () => {
      this.log('onshippingcontactselected');
      this.session.completeShippingContactSelection(window.ApplePaySession.STATUS_SUCCESS);
    };

    this.session.onshippingmethodselected = () => {
      this.log('onshippingmethodselected');
      this.session.completeShippingMethodSelection(window.ApplePaySession.STATUS_SUCCESS);
    };

    this.session.onpaymentauthorized = (event) => {
      const { token } = event.payment;
      this.log(`payment authorization | token = ${token}`);
      this.session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
    };

    this.session.oncancel = () => {
      this.log('payment cancel error');
    };

    this.log('session.begin()');

    // Start merchant validation process
    this.session.begin();
  }

  // eslint-disable-next-line class-methods-use-this
  onValidateMerchant(event) {
    this.log('onValidateMerchange');

    return fetch(MOLLIE_APPLE_PAY_SESSION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        validationUrl: event.validationURL,
        domain: 'www.bekkingblitz.nl',
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }

        this.log(`Invalid request to ${MOLLIE_APPLE_PAY_SESSION_URL}`);
        this.session.abort();

        throw new Error('Invalid request');
      })
      .then((data) => {
        this.log(JSON.stringify(data));
        this.session.completeMerchantValidation(data);
      })
      .catch(() => {
        this.session.abort();
      });
  }

  log(txt) {
    const logEl = document.createElement('div');
    logEl.innerHTML = txt;
    logEl.setAttribute('style', 'background: red; color: #fff; padding: 5px 10px');
    this.element.after(logEl);
    // eslint-disable-next-line no-console
    console.log(txt);
  }
}

export default ApplePay;
